var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCircleVeryHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 202 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101 21C90.4942 21 80.0914 23.0692 70.3854 27.0896C60.6793 31.11 51.8602 37.0027 44.4315 44.4314C37.0028 51.8601 31.11 60.6792 27.0897 70.3853C23.0693 80.0913 21 90.4942 21 101C21 106.523 16.5228 111 11 111C5.47715 111 0.999997 106.523 1 101C1.00001 87.8678 3.58659 74.8642 8.61207 62.7316C13.6375 50.599 21.0035 39.5751 30.2894 30.2893C39.5752 21.0034 50.5992 13.6375 62.7317 8.61202C74.8643 3.58656 87.8678 0.999991 101 1C114.132 1 127.136 3.58658 139.268 8.61205C151.401 13.6375 162.425 21.0035 171.711 30.2893C180.997 39.5752 188.362 50.5991 193.388 62.7317C198.413 74.8642 201 87.8678 201 101C201 106.523 196.523 111 191 111C185.477 111 181 106.523 181 101C181 90.4943 178.931 80.0914 174.91 70.3853C170.89 60.6793 164.997 51.8602 157.569 44.4315C150.14 37.0028 141.321 31.11 131.615 27.0896C121.909 23.0693 111.506 21 101 21Z",
    fill: "#E9EAEB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.273 33.6046C165.345 29.8702 171.632 30.1895 175.315 34.3178C191.593 52.561 200.728 76.2094 200.999 100.808C201.061 106.374 196.66 110.937 191.169 110.999C185.679 111.062 181.178 106.6 181.116 101.033C180.899 81.3547 173.591 62.436 160.569 47.8414C156.886 43.7131 157.201 37.3391 161.273 33.6046Z",
    fill: "#063D8F",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCircleVeryHigh);
export default __webpack_public_path__ + "static/media/progress-circle-very-high.6a054587e95a5b1301cc739b6977e2ae.svg";
export { ForwardRef as ReactComponent };